import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { IconSwitchComponent } from './icon-switch.component';

@NgModule({
    imports: [TwcModule, CommonModule, FormsModule, TranslateModule],
    declarations: [IconSwitchComponent],
    exports: [IconSwitchComponent],
})
export class IconSwitchModule {}
